import { createElement } from 'react';
import { Balloon, Message } from '@alifd/next';
import copy from 'copy-to-clipboard';
const TitleTooltip = ({ children }) => {
    const onDoubleClick = () => {
        copy(children);
        Message.success('复制成功!');
    };
    return (createElement(Balloon.Tooltip, { align: "r", v2: true, arrowPointToCenter: true, trigger: createElement("span", { style: { userSelect: 'all' }, onDoubleClick: onDoubleClick }, children) }, children));
};
export default TitleTooltip;
